const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "aetheria-voter";

export function voterId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(
      /[^A-Za-z0-9-]/g,
      ""
    );
    localStorage.setItem(KEY, id);
  }
  return id;
}

export async function fetchAllTallies() {
  const r = await fetch(`${API}/api/votes`);
  if (!r.ok) throw new Error("tallies failed");
  return r.json();
}

export async function fetchTally(siteId) {
  const r = await fetch(`${API}/api/votes/${siteId}?voter_id=${voterId()}`);
  if (!r.ok) throw new Error("tally failed");
  return r.json();
}

export async function castVote(siteId, hypothesis) {
  const r = await fetch(`${API}/api/votes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ site_id: siteId, hypothesis, voter_id: voterId() }),
  });
  if (!r.ok) throw new Error("vote failed");
  return r.json();
}

export async function retractVote(siteId) {
  const r = await fetch(`${API}/api/votes/${siteId}?voter_id=${voterId()}`, { method: "DELETE" });
  if (!r.ok) throw new Error("retract failed");
  return r.json();
}
